/**
 * The learner's own calendar date, from the browser's zone. Day N and
 * "today" are the learner's day, never the server's UTC one, so every query
 * and mutation that takes `localDay` is sent this (lesson library PRD §4.2).
 * Built from local fields rather than `toISOString`, which is UTC.
 */
export function localDay(now: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}
